import React, { useState } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const PerformanceAppraisal = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const data = [
    { key: "1", name: "Antony", designation: "Web Designer", dept: "Designing", date: "14 Jan 2024", status: "Active" },
    { key: "2", name: "Antony", designation: "Mobile Designer", dept: "Designing", date: "14 Jan 2024", status: "Active" },
    { key: "3", name: "Antony", designation: "Web Designer", dept: "Designing", date: "14 Jan 2024", status: "Active" },
    { key: "4", name: "Antony", designation: "Web Designer", dept: "Designing", date: "14 Jan 2024", status: "Active" },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { title: "", render: () => <input type="checkbox" />, width: 50 },
    { title: "Name", dataIndex: "name" },
    { title: "Designation", dataIndex: "designation" },
    { title: "Department", dataIndex: "dept" },
    { title: "Appraisal Date", dataIndex: "date" },
    { title: "Status", dataIndex: "status" },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Performance Appraisal List"
      columns={columns}
      data={filteredData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearchText}
    />
  );
};

export default PerformanceAppraisal;